export default __webpack_public_path__ + "static/media/exmoor.a7a1bde1.jpg";